/* Product page (sections/product.liquid): option details and switching, the Add-ons drawer and the
   source of its add-ons (the product's option set), the delivery date, the saving line, the section
   menu, the buy panel's position, video (the strip and its player), the description's phone collapse, the
   specifications cut and the phone bar. It only reads and restyles
   what the theme scripts and apps already write; they keep their own hooks. */
(function () {
  'use strict';

  var root = document.querySelector('.dmp');
  if (!root) return;

  var form = root.querySelector('.dmp-form') || root.querySelector('form[action*="/cart/add"]');
  var phone = window.matchMedia('(max-width: 767px)');
  var desktop = window.matchMedia('(min-width: 1024px)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var product = null;
  var config = {};
  try { product = JSON.parse(root.querySelector('.product-json').textContent); } catch (e) {}
  try { config = JSON.parse(document.getElementById('dmp-config').textContent) || {}; } catch (e) {}
  var b2bPrices = config.b2b || null;
  var isB2B = !!root.querySelector('[data-dmp-price][data-b2b]');

  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function norm(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); }
  function money(cents) { return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function moneyShort(cents) {
    var d = Math.abs(cents) / 100;
    return '$' + (d % 1 ? d.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : d.toLocaleString('en-US'));
  }
  function behavior() { return calm.matches ? 'auto' : 'smooth'; }
  function joinList(a) { return a.length < 2 ? (a[0] || '') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function throttle(fn) {
    var queued = false;
    return function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; fn(); });
    };
  }
  function onMedia(mql, fn) { if (mql.addEventListener) mql.addEventListener('change', fn); else if (mql.addListener) mql.addListener(fn); }

  /* ---------- Variant options ---------- */
  var groups = $$('.dmp-opt');
  var switchNote = null;
  var descItems = null;

  function chosen() {
    return groups.map(function (g) {
      var r = g.querySelector('.dmp-chip__input:checked');
      return r ? norm(r.value) : null;
    });
  }
  function variantFor(opts) {
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var ok = true;
      for (var j = 0; j < opts.length; j++) { if (norm(v.options[j]) !== opts[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function currentVariant() {
    var v = groups.length ? variantFor(chosen()) : null;
    if (!v && product) {
      var sel = form && form.querySelector('select[name="id"]');
      var id = sel ? String(sel.value) : '';
      v = product.variants.filter(function (x) { return String(x.id) === id; })[0] || product.variants[0];
    }
    return v;
  }
  function priceOf(v) { return b2bPrices && b2bPrices[v.id] != null ? Math.round(b2bPrices[v.id] * 100) : v.price; }
  function isColor(gi) { return !!(groups[gi] && groups[gi].classList.contains('dmp-opt--color')); }

  // What picking this value does to the other choices: "With Microlux Fabric" when one choice moves,
  // "Changes material and colour" when more do. Nothing is crossed out for being an unusual
  // combination, because every value can be picked and the page moves the rest to match.
  function withText(gi, best, opts) {
    var changed = [];
    best.options.forEach(function (o, k) { if (k !== gi && norm(o) !== opts[k]) changed.push(k); });
    if (!changed.length) return '';
    if (changed.length === 1) return (isColor(changed[0]) ? 'In ' : 'With ') + norm(best.options[changed[0]]);
    return 'Changes ' + joinList(changed.map(function (k) { return String(product.options[k] || '').toLowerCase(); }));
  }

  function paintOptions() {
    if (!product || !groups.length) return;
    var opts = chosen();
    var cur = variantFor(opts);
    groups.forEach(function (g, gi) {
      var current = g.querySelector('[data-dmp-current]');
      if (current) current.textContent = opts[gi] || '';
      $$('.dmp-chip', g).forEach(function (chip) {
        var input = chip.querySelector('.dmp-chip__input');
        var val = norm(input.value);
        var trial = opts.slice();
        trial[gi] = val;
        var v = variantFor(trial);
        var text = '';
        input.disabled = false; // every value can be picked; the others switch to match (see onOptionChange)
        var swap = !v && !input.checked ? bestFor(gi, val, opts) : null; // picking it moves the other choices
        chip.classList.toggle('is-switch', !!swap);
        chip.classList.toggle('is-soldout', (!!v && !v.available && !input.checked) || (!!swap && !swap.available));
        if (input.checked) text = 'Selected';
        else if (swap) text = swap.available ? withText(gi, swap, opts) : 'Sold out';
        else if (!v) text = 'Not available';
        else if (!v.available) text = 'Sold out';
        else if (cur) {
          var d = priceOf(v) - priceOf(cur);
          text = d === 0 ? 'Same price' : (d > 0 ? '+' : '−') + moneyShort(d);
        }
        var detail = chip.querySelector('[data-dmp-detail]');
        if (detail) detail.textContent = text;
      });
    });
  }

  // A line from the product's own description that explains the chosen value,
  // e.g. "Standard - 24" Spoked Polyurethane Flat-Free Wheels" → "Standard: 24" Spoked…".
  function describe(val) {
    if (!val) return '';
    if (!descItems) descItems = $$('.dmp-sec li').map(function (li) { return norm(li.textContent); });
    var low = val.toLowerCase();
    for (var i = 0; i < descItems.length; i++) {
      var t = descItems[i];
      if (t.toLowerCase().indexOf(low) !== 0) continue;
      var m = t.slice(val.length).match(/^\s*(?:-|–|—|:)\s*(.+)$/);
      if (m) return val + ': ' + m[1];
    }
    return '';
  }
  // Under the colour row: "Alpine White comes in 18\"x17\" with Standard wheels only." for colours that
  // are made in fewer combinations than the others.
  function colourNote(gi, opts) {
    if (!product || !groups[gi]) return '';
    var val = opts[gi];
    if (!val) return '';
    var made = product.variants.filter(function (v) { return norm(v.options[gi]) === val; });
    if (!made.length) return '';
    var parts = [];
    groups.forEach(function (g, k) {
      if (k === gi) return;
      var all = $$('.dmp-chip__input', g).map(function (x) { return norm(x.value); });
      var have = all.filter(function (a) { return made.some(function (v) { return norm(v.options[k]) === a; }); });
      if (have.length && have.length < all.length) parts.push(String(product.options[k] || '').toLowerCase() + ' ' + have.join(' or '));
    });
    if (!parts.length) return '';
    return val + ' comes in ' + joinList(parts) + ' only.';
  }
  // The elements matching sel that belong to a group itself, not to a group drawn inside it (a compact list holds
  // the size groups its rows open, each with its own values, message and note).
  function own(g, sel) {
    return $$(sel, g).filter(function (el) { var owner = el.closest('[data-dmp-group]'); return !owner || owner === g; });
  }
  function setNote(g, text) {
    var n = own(g, '[data-dmp-note]')[0];
    if (!n) return;
    var span = n.querySelector('[data-dmp-note-text]');
    if (span) span.textContent = text || '';
    n.hidden = !text;
  }
  // A short tint on a group the page changed for the shopper.
  function flash(g) {
    if (!g || calm.matches) return;
    g.classList.remove('is-switched');
    void g.offsetWidth;
    g.classList.add('is-switched');
    setTimeout(function () { g.classList.remove('is-switched'); }, 1900);
  }
  function paintNotes() {
    var opts = chosen();
    groups.forEach(function (g, gi) {
      if (switchNote && switchNote.gi === gi) { setNote(g, switchNote.text); return; }
      setNote(g, isColor(gi) ? colourNote(gi, opts) : describe(opts[gi]));
    });
  }

  function bestFor(gi, val, opts) {
    var best = null;
    var score = -1;
    product.variants.forEach(function (v) {
      if (norm(v.options[gi]) !== val) return;
      var s = v.options.reduce(function (n, o, k) { return n + (norm(o) === opts[k] ? 2 : 0); }, 0) + (v.available ? 1 : 0);
      if (s > score) { score = s; best = v; }
    });
    return best;
  }
  function applyVariant(v) {
    var selects = $$('.single-option-selector', form);
    v.options.forEach(function (o, k) {
      var match = groups[k] && $$('.dmp-chip__input', groups[k]).filter(function (x) { return norm(x.value) === norm(o); })[0];
      if (match) match.checked = true;
      if (selects[k]) selects[k].value = o;
    });
    if (window.jQuery && selects[0]) window.jQuery(selects[0]).trigger('change');
  }

  // Everything that follows the chosen variant. Other parts of the page, such as the add-on sizes matched
  // to the seat, add themselves to optionWatchers.
  var optionWatchers = [];
  function onOptionChange() {
    if (!product) return;
    paintOptions();
    paintNotes();
    syncPrice();
    optionWatchers.forEach(function (watcher) { watcher(); });
  }

  // Picking a value that is not made with the other choices moves those choices to the closest
  // variant that has it, and says so under the group. This runs in the capture phase, before the
  // theme's own radio handler: that handler reads every option select, and the theme's variant
  // callback fails on a combination that does not exist.
  if (form) {
    form.addEventListener('change', function (e) {
      var input = e.target && e.target.closest ? e.target.closest('.dmp-chip__input') : null;
      if (!input || !product) return;
      var gi = groups.indexOf(input.closest('.dmp-opt'));
      var opts = chosen();
      switchNote = null;
      if (gi > -1 && !variantFor(opts)) {
        var val = opts[gi];
        var best = bestFor(gi, val, opts);
        if (best) {
          var selects = $$('.single-option-selector', form);
          var changed = [];
          best.options.forEach(function (o, k) {
            if (k === gi) return;
            if (norm(o) !== opts[k]) changed.push(k);
            var match = groups[k] && $$('.dmp-chip__input', groups[k]).filter(function (x) { return norm(x.value) === norm(o); })[0];
            if (match) match.checked = true;
            if (selects[k]) selects[k].value = o;
          });
          if (changed.length) {
            var parts = changed.map(function (k) { return String(product.options[k] || '').toLowerCase() + ' ' + norm(best.options[k]); });
            switchNote = { gi: gi, text: val + ' comes in ' + joinList(parts) + ', so we switched ' + (changed.length > 1 ? 'those' : 'that') + ' for you.' };
            changed.forEach(function (k) { flash(groups[k]); });
          }
          if (!window.jQuery) applyVariant(best);
        }
      }
      setTimeout(onOptionChange, 0);
    }, true);
    if (window.jQuery) {
      window.jQuery(form).on('change', '.single-option-selector', function () { setTimeout(onOptionChange, 0); });
    }
  }

  /* ---------- Price: saving and normal price for shoppers without business pricing ---------- */
  function syncPrice() {
    var save = $('.save-tag');
    if (isB2B) {
      // the wholesale app writes "YOU SAVE: $x"; same words as everywhere else on the page
      if (save && /:/.test(save.textContent)) save.textContent = save.textContent.replace(/you save:\s*/i, 'You save ');
      return;
    }
    var v = currentVariant();
    var ctp = $('.compare-tagged-price');
    var cmp = document.getElementById('comparePrice');
    if (!v || !save || !ctp || !cmp) return;
    // the price shown includes the chosen add-ons, so the normal price counts them at their regular prices
    var shown = v.price + addOnCents();
    var normalCents = Math.max(v.price, v.compare_at_price || 0) + addOnCents(true);
    if (normalCents > shown) {
      var normal = money(normalCents);
      if (cmp.textContent !== normal) cmp.textContent = normal;
      cmp.style.display = 'block';
      ctp.style.display = 'flex';
      var saving = 'You save ' + money(normalCents - shown);
      if (save.textContent !== saving) save.textContent = saving;
      save.style.display = 'inline-flex';
    } else {
      ctp.style.display = 'none';
      save.style.display = 'none';
    }
  }

  /* ---------- Delivery date (theme ETA script writes #eta-container) ---------- */
  var etaBox = document.getElementById('eta-container');
  // The date rule's third copy, with getDateNBizDaysAhead() in snippets/product-wholesale-pricing.liquid and
  // snippets/dmp-eta-held.liquid: change the three together (node --test tools/theme-tests/delivery-date.test.mjs).
  function formatEta(raw) {
    var m = raw.match(/^([A-Za-z]{3,9})\s+(\d{1,2}),\s*(\d{4})(?:\s*[-–]\s*([A-Za-z]{3,9})\s+(\d{1,2}),\s*(\d{4}))?$/);
    if (!m) return raw;
    if (!m[4]) return m[1] + ' ' + m[2];
    if (m[1] === m[4] && m[3] === m[6]) return m[1] + ' ' + m[2] + ' – ' + m[5];
    return m[1] + ' ' + m[2] + ' – ' + m[4] + ' ' + m[5];
  }
  function syncEta() {
    if (!etaBox || etaBox.classList.contains('eta-freight')) return;
    var etaEl = etaBox.querySelector('.fsc-eta');
    var note = etaBox.querySelector('.order-note-eta');
    var loader = etaBox.querySelector('.loader-holder.small');
    var raw = etaEl ? norm(etaEl.textContent).replace(/^ETA:\s*/i, '') : '';
    var loading = !!(loader && loader.style.display && loader.style.display !== 'none');
    var gone = etaBox.style.display === 'none';
    var backordered = !!(note && note.style.display === 'block');
    var show = !!raw && !loading && !gone;
    var date = show ? formatEta(raw) : '';
    $$('[data-dmp-eta-copy]').forEach(function (line) {
      line.hidden = !show;
      var label = line.querySelector('[data-dmp-eta-label]');
      var d = line.querySelector('[data-dmp-eta-date]');
      // Written only when there is a date to show: while the date script works (its loader shows) the backorder note is
      // not shown yet, and a label written then ("Estimated delivery") shortened the held line of a backorder, whose
      // label and date the server printed (sections/product.liquid), so its row shrank and grew again 0.5 s later.
      if (!show) return;
      if (label) label.textContent = backordered ? 'Backordered · expected to ship' : 'Estimated delivery';
      if (d) d.textContent = date;
    });
    var n = $('[data-dmp-eta-note]');
    if (n) n.hidden = !(show && backordered);
    // The room the row held for its date from the first paint (dmp-ship--held, sections/product.liquid) is let go once
    // the date script has written a date or put the block away: from then on the row is as tall as what it shows.
    if (show || gone) releaseShip();
  }
  function releaseShip() { $$('.dmp-ship--held').forEach(function (row) { row.classList.remove('dmp-ship--held'); }); }

  /* ---------- Add-ons: where the option groups come from ----------
     The Add-ons drawer reads add-on state through one interface: a source has refresh(), which returns
     { groups, single, matchedTo }, plus total(), addsToPagePrice, addButton(), pickedAddOns(),
     soldOut(words) and watch(changed, refused). The product's option set (ADR-0002) is the only source:
     Advanced Product Options (APO), uninstalled 2026-09-21, was the other until its source was removed. */

  // A linked product's option groups, drawn by snippets/dmp-addons.liquid: a fieldset per group and a tick
  // box per value carrying its variant, price, name, the add-on's name on an order and, when it comes in
  // sizes, the seat widths it fits. A type chooser (no variant) opens its dependent groups, which the source
  // shows while it is chosen, with the size that fits the main product's seat picked in advance. Null on a
  // page without them.
  function optionSetSource() {
    var mount = $('[data-dmp-option-set]');
    if (!mount) return null;
    var seatOption = parseInt(mount.getAttribute('data-seat-option'), 10);
    function allValues() { return $$('[data-dmp-value]', mount); }
    function values(group) { return own(group, '[data-dmp-value]'); }
    function ticked(group) { return values(group).filter(function (i) { return i.checked; }); }
    function sized(group) { return values(group).filter(function (i) { return i.hasAttribute('data-fits'); }); }
    // What a value costs this shopper and its regular price, in cents (the regular price is never below the price).
    function priceOf(input) {
      var paid = parseInt(input.getAttribute('data-price'), 10) || 0;
      return { paid: paid, regular: Math.max(parseInt(input.getAttribute('data-regular'), 10) || 0, paid) };
    }
    // What picked values add up to, leaving out any Shopify refused as sold out: it can't be bought.
    function sumOf(inputs) {
      return inputs.filter(function (i) { return !refused(i); }).reduce(function (sum, i) {
        var price = priceOf(i);
        return { paid: sum.paid + price.paid, regular: sum.regular + price.regular };
      }, { paid: 0, regular: 0 });
    }
    function nameOf(i) { return i.getAttribute('data-name'); }
    function selectIn(group) { return group.querySelector('[data-dmp-select]'); }
    // A group shown as a dropdown is worked through one select, while the tick boxes behind it stay what the
    // rest of the drawer reads and what the browser ticks again on the way back from the cart.
    function syncSelects() {
      $$('[data-dmp-select]', mount).forEach(function (sel) {
        var group = sel.closest('[data-dmp-group]');
        var on = ticked(group)[0];
        var want = on ? on.getAttribute('data-value') : '';
        if (sel.value !== want) sel.value = want;
      });
    }
    // Choosing in the list works its tick boxes and then lets the box speak for itself, so everything that
    // follows a pick (the running total, the Add-ons row, a group's error) happens exactly as it does for a
    // card: the drawer's own listener below only ever answers to a value's own change.
    mount.addEventListener('change', function (e) {
      var sel = e.target && e.target.closest && e.target.closest('[data-dmp-select]');
      if (!sel) return;
      var group = sel.closest('[data-dmp-group]');
      var was = ticked(group)[0] || null;
      var picked = null;
      values(group).forEach(function (i) {
        var wanted = i.getAttribute('data-value') === sel.value;
        i.checked = wanted;
        if (wanted) picked = i;
      });
      // back to "Choose …": the box that was picked is the one that changed, and the drawer has to hear it
      var speaks = picked || was;
      if (speaks) speaks.dispatchEvent(new Event('change', { bubbles: true }));
    });
    // A customization has no product to add (a fabric, a finish, a frame colour): the shopper's pick rides on
    // the product's own line as a note, so the order and the vendor's purchase order say what to build
    // (Chris, 2026-09-16). A hidden field per group in the product form carries it, whichever way the page
    // adds to cart.
    function notes() {
      return $$('[data-dmp-group]', mount).filter(function (g) { return !g.hidden; }).map(function (g) {
        return { label: g.getAttribute('data-label') || '', picked: ticked(g).filter(function (i) { return i.hasAttribute('data-note'); }).map(nameOf) };
      }).filter(function (n) { return n.label && n.picked.length; });
    }
    function writeNotes() {
      if (!form) return;
      var box = form.querySelector('[data-dmp-notes]');
      if (!box) { box = document.createElement('span'); box.setAttribute('data-dmp-notes', ''); box.hidden = true; form.appendChild(box); }
      var want = notes();
      if (box.getAttribute('data-written') === JSON.stringify(want)) return;
      box.setAttribute('data-written', JSON.stringify(want));
      box.textContent = '';
      want.forEach(function (n) {
        var field = document.createElement('input');
        field.type = 'hidden';
        // the label names the line item property; brackets would break the field's own name
        field.name = 'properties[' + n.label.replace(/[[\]]/g, '') + ']';
        field.value = n.picked.join(', ');
        box.appendChild(field);
      });
    }
    function shownValues() { return allValues().filter(function (i) { return !i.closest('[data-dmp-group]').hidden; }); }
    // The main product's chosen seat size, as its variant names it ("16"x17"").
    function seat() {
      var v = seatOption >= 0 ? currentVariant() : null;
      return v ? norm(v.options[seatOption]) : '';
    }
    function fits(input, width) {
      var range = (input.getAttribute('data-fits') || '').split('-');
      return width !== null && width >= parseFloat(range[0]) && width <= parseFloat(range[range.length - 1]);
    }
    // The sizes in a group that fit the main product's seat: its first number is the width (16"x17" → 16).
    function fitting(group) {
      var m = seat().match(/\d+(\.\d+)?/);
      var width = m ? parseFloat(m[0]) : null;
      return sized(group).filter(function (i) { return fits(i, width); });
    }
    // Marks each size in a dependent group that fits the main product's seat ("Fits · $357"), and notes only
    // what the marks don't say: "2 sizes fit your 18"x17" chair. Pick one." while several fit and none is
    // picked (the group's own error does the asking once it shows), or that the picked size doesn't fit.
    function showFit(group) {
      var fit = fitting(group);
      sized(group).forEach(function (i) {
        var mark = i.parentNode.querySelector('.dmp-size__fits');
        if (mark) mark.hidden = fit.indexOf(i) < 0;
      });
      var pick = ticked(group)[0];
      setNote(group, pick ? (fit.length && fit.indexOf(pick) < 0 ? 'The picked size doesn’t fit your ' + seat() + ' chair.' : '')
        : fit.length > 1 ? fit.length + ' sizes fit your ' + seat() + ' chair.' + (asks(group) ? '' : ' Pick one.')
        : '');
    }
    // Picks the size that fits the main product's seat in a dependent group, where several fit none, unless the
    // size already picked there fits it: add-ons are bought for this product, so even a size the shopper
    // picked moves when it no longer fits the seat (Chris, 2026-09-14).
    function matchSize(group) {
      var sizes = sized(group);
      if (!sizes.length || group.hidden) return;
      var fit = fitting(group);
      var picked = sizes.filter(function (i) { return i.checked; })[0];
      if (!picked || fit.indexOf(picked) < 0) sizes.forEach(function (i) { i.checked = fit.length === 1 && i === fit[0]; });
      showFit(group);
    }
    // A regular price the shopper isn't paying, struck through after a price, as the page is served with it.
    function appendWas(el, regular) {
      var hint = document.createElement('span');
      hint.className = 'dmp-sr';
      hint.textContent = ', normally';
      var was = document.createElement('s');
      was.className = 'dmp-addon-was';
      was.textContent = moneyShort(regular);
      el.appendChild(hint);
      el.appendChild(document.createTextNode(' '));
      el.appendChild(was);
    }
    // A type chooser's own price is for this chair: the sizes it opens that fit the main product's seat ("$447",
    // or "From $357" when they cost different amounts), with that size's higher regular price struck through.
    // The page is served with the lowest price of every size, kept where no size fits the seat.
    function priceForSeat(chooser, dependents) {
      var line = chooser.parentNode.querySelector('[data-dmp-addon-price]');
      if (!line) return;
      if (!line.hasAttribute('data-served')) line.setAttribute('data-served', line.innerHTML);
      var fit = [];
      dependents.forEach(function (g) { fit = fit.concat(fitting(g).filter(function (i) { return i.hasAttribute('data-price'); })); });
      var key = fit.map(function (i) { var price = priceOf(i); return price.paid + '/' + price.regular; }).join(' ');
      if (line.getAttribute('data-for-seat') === key) return;
      line.setAttribute('data-for-seat', key);
      if (!fit.length) { line.innerHTML = line.getAttribute('data-served'); return; }
      var low = fit.map(priceOf).reduce(function (a, b) { return b.paid < a.paid ? b : a; });
      var differ = fit.some(function (i) { return priceOf(i).paid !== low.paid; });
      line.textContent = (differ ? 'From ' : '') + moneyShort(low.paid);
      if (low.regular > low.paid) appendWas(line, low.regular);
    }
    // A picked type chooser says what the value picked in a group it opens costs, with a higher regular price
    // struck through after it as the cards show theirs: "Added · $198, normally $447". A compact list row's
    // span (data-bare) takes the price alone, in place of its own price. Picked while none of its sizes is (a
    // size Shopify refused as sold out doesn't count), it reads "Choose size" (data-incomplete) until one is.
    function priceChoosers() {
      $$('[data-opens]', mount).forEach(function (chooser) {
        var span = chooser.parentNode.querySelector('[data-dmp-added-price]');
        if (!span) return;
        var dependents = chooser.getAttribute('data-opens').split(' ').map(function (h) { return mount.querySelector('[data-group="' + h + '"]'); }).filter(Boolean);
        var shownDependents = dependents.filter(function (g) { return !g.hidden; });
        var pick = shownDependents.map(function (g) {
          return ticked(g).filter(function (i) { return i.hasAttribute('data-price') && !refused(i); })[0];
        }).filter(Boolean)[0];
        if (chooser.checked && !pick && shownDependents.length) chooser.setAttribute('data-incomplete', '');
        else chooser.removeAttribute('data-incomplete');
        priceForSeat(chooser, dependents);
        var price = pick ? priceOf(pick) : null;
        var shown = price ? price.paid + ' ' + price.regular : '';
        if (span.getAttribute('data-shown') === shown) return;
        span.setAttribute('data-shown', shown);
        span.textContent = '';
        if (price && !span.hasAttribute('data-bare')) {
          var sep = document.createElement('span');
          sep.className = 'dmp-card__sep';
          sep.setAttribute('aria-hidden', 'true');
          sep.textContent = '· ';
          span.appendChild(sep);
        }
        if (price) span.appendChild(document.createTextNode(moneyShort(price.paid)));
        if (price && price.regular > price.paid) appendWas(span, price.regular);
        // a card with a struck regular price puts its price on a line of its own
        var added = span.closest('.dmp-card__added');
        if (added) added.classList.toggle('dmp-card__added--was', !!price && price.regular > price.paid);
      });
    }
    // A group's error, on the fields it concerns: kind "required" for a required group left unanswered (all
    // its fields), "sold-out" for an add-on Shopify refused as sold out (its own field, whose status then
    // reads "Sold out").
    function showError(group, kind, text, fields) {
      var err = own(group, '[data-dmp-error]')[0];
      if (!err) return;
      if (err.textContent !== text) err.textContent = text;
      err.hidden = false;
      var remove = own(group, '[data-dmp-remove]')[0];
      if (remove) remove.hidden = kind !== 'sold-out';
      group.setAttribute('data-error', kind);
      // a dropdown group is answered through its select, so the message is on that
      var sel = selectIn(group);
      if (sel) { sel.setAttribute('aria-invalid', 'true'); sel.setAttribute('aria-describedby', err.id); }
      values(group).forEach(function (i) {
        var gone = kind === 'sold-out' && fields.indexOf(i) > -1;
        var status = i.parentNode.querySelector('.dmp-addon-sold-out');
        if (status) status.hidden = !gone;
        if (fields.indexOf(i) < 0) { unmark(i); return; }
        i.setAttribute('aria-invalid', 'true');
        i.setAttribute('aria-describedby', err.id);
      });
      showFit(group);
      priceChoosers(); // a refused size stops counting as its cushion's pick
      writePrice();
    }
    function unmark(field) { field.removeAttribute('aria-invalid'); field.removeAttribute('aria-describedby'); }
    function clearError(group) {
      if (!group.hasAttribute('data-error')) return;
      group.removeAttribute('data-error');
      var err = own(group, '[data-dmp-error]')[0];
      if (err) { err.hidden = true; err.textContent = ''; }
      var remove = own(group, '[data-dmp-remove]')[0];
      if (remove) remove.hidden = true;
      values(group).forEach(unmark);
      var cleared = selectIn(group);
      if (cleared) unmark(cleared);
      own(group, '.dmp-addon-sold-out').forEach(function (status) { status.hidden = true; });
      showFit(group);
      priceChoosers(); // a refused size stops counting as its cushion's pick
      writePrice();
    }
    // Whether a group's error is asking for its answer.
    function asks(group) { return group.getAttribute('data-error') === 'required'; }
    // Whether a picked add-on is one Shopify refused as sold out: it stays picked and marked, but counts for
    // nothing until the shopper picks another or removes it.
    function refused(input) {
      var group = input.closest('[data-dmp-group]');
      return input.getAttribute('aria-invalid') === 'true' && !!group && group.getAttribute('data-error') === 'sold-out';
    }
    // The add-on in a group Shopify refused as sold out, while it is still picked.
    function soldOutIn(group) { return ticked(group).filter(refused)[0] || null; }
    // The add-on a value stands for: a size stands for the value that opened its group (that cushion, in that size).
    function addOnOf(input) {
      var group = input.closest('[data-dmp-group]');
      return group && group.hasAttribute('data-show-when') ? openerOf(group) || input : input;
    }
    // The price at the top of the page includes the picked add-ons at the prices this shopper pays, as the old
    // options app's did (Chris, 2026-09-14). While the wholesale script (snippets/product-wholesale-pricing.liquid) prices
    // the variant for a business account, the price is its own: it adds window.dmpAddOnSums on "dmp:addons".
    // Otherwise the price is written here, and put back whenever the theme writes the plain variant price.
    var priceEl = document.getElementById('productPrice');
    function wholesaleOwnsPrice() { return !!window.dmB2BScript && window.dmB2BPriced !== false; }
    function writePrice() {
      var sums = sumOf(shownValues().filter(function (i) { return i.checked; }));
      // the wholesale script re-prices (behind its loader) only when the sums really change
      var changedSums = window.dmpAddOnSums ? window.dmpAddOnSums.paid !== sums.paid || window.dmpAddOnSums.regular !== sums.regular : sums.paid > 0;
      window.dmpAddOnSums = { paid: sums.paid, regular: sums.regular };
      if (wholesaleOwnsPrice()) { if (changedSums) document.dispatchEvent(new CustomEvent('dmp:addons')); return; }
      var v = currentVariant();
      if (!v || !priceEl) return;
      var text = money(v.price + sums.paid);
      if (norm(priceEl.textContent) !== text) priceEl.textContent = text;
    }
    // Clears the errors the shopper has dealt with: a required group now answered or gone, a sold-out add-on
    // no longer picked.
    function clearSolved() {
      $$('[data-dmp-group][data-error]', mount).forEach(function (g) {
        if (g.hidden || (asks(g) ? ticked(g).length > 0 : !soldOutIn(g))) clearError(g);
      });
    }
    // The picked value in a shown group that opens a dependent group, if any.
    function openerOf(group) {
      var when = group.getAttribute('data-show-when').split(' ');
      return shownValues().filter(function (i) { return i.checked && when.indexOf(i.getAttribute('data-value')) > -1; })[0] || null;
    }
    // Shows the dependent groups a picked value opens and hides the rest, clearing what was picked in them,
    // until nothing changes (a group closing can close the groups its values opened).
    function openGroups() {
      var dependents = $$('[data-show-when]', mount);
      for (var pass = 0, moved = true; moved && pass <= dependents.length; pass++) {
        moved = false;
        dependents.forEach(function (g) {
          var open = !!openerOf(g);
          if (open === !g.hidden) return;
          moved = true;
          g.hidden = !open;
          if (open) { matchSize(g); return; }
          values(g).forEach(function (i) { i.checked = false; });
          clearError(g);
        });
      }
    }
    return {
      refresh: function () {
        clearSolved();
        syncSelects();
        writeNotes(); // the product's line carries the customizations picked, however it is added
        var all = allValues();
        return {
          groups: $$('[data-dmp-group]', mount).map(function (g) {
            var on = ticked(g);
            var sums = sumOf(on);
            var dependent = g.hasAttribute('data-show-when');
            var opener = dependent ? openerOf(g) : null;
            var gone = soldOutIn(g);
            return {
              label: g.getAttribute('data-label') || '',
              shown: !g.hidden,
              required: g.hasAttribute('data-required'),
              dependent: dependent,
              dependsOn: opener ? nameOf(opener) : '',
              picked: on.filter(function (i) { return !i.hasAttribute('data-note'); }).map(nameOf),
              // a customization adds no line and costs nothing: it is a choice made, not an add-on added
              notes: on.filter(function (i) { return i.hasAttribute('data-note'); }).map(nameOf),
              cents: sums.paid,
              regularCents: sums.regular,
              answered: on.length > 0,
              flagged: asks(g), // the shopper was already told it needs an answer
              soldOut: gone ? nameOf(addOnOf(gone)) : '', // a picked add-on Shopify refused as sold out
              control: gone || selectIn(g) || values(g)[0], // what to focus
              flag: function (text) { showError(g, 'required', text, values(g)); }
            };
          }),
          single: all.length === 1 ? nameOf(all[0]) : '',
          // the main product's seat the sizes are matched to, when anything here comes in sizes
          matchedTo: mount.querySelector('[data-fits]') ? seat() : ''
        };
      },
      // The price at the top of the page includes the picked add-ons (writePrice), so it is the running total,
      // written the page's way ("$1,297.00") even when the wholesale script wrote "$1297.00".
      total: function () {
        var text = pagePrice();
        return text ? money(Math.round(parseFloat(text.replace(/[^0-9.]/g, '')) * 100)) : '';
      },
      addsToPagePrice: true,
      addButton: function () { return null; },
      // The picked add-ons to add with the product: each variant, and what its order line calls it. A type
      // chooser is no add-on of its own; its size is.
      pickedAddOns: function () {
        return shownValues().filter(function (i) { return i.checked && i.hasAttribute('value'); }).map(function (i) { return { id: Number(i.value), line: i.getAttribute('data-line') }; });
      },
      // Shopify refused the add because a picked add-on sold out, naming it the way its cart does ("The product
      // 'Karman Push Button Wheelchair Seat Belt' is already sold out."): says so on that add-on and returns
      // its field, or null when the words name no picked add-on. A size names the add-on it sizes too.
      soldOut: function (words) {
        var quoted = norm(words).match(/'(.+)' is already sold out/i);
        var named = quoted ? shownValues().filter(function (i) { return i.checked && norm(i.getAttribute('data-cart-name')) === quoted[1]; })[0] : null;
        if (!named) return null;
        var addOn = addOnOf(named);
        var name = addOn !== named ? nameOf(addOn) + ' (' + nameOf(named) + ')' : nameOf(named);
        showError(named.closest('[data-dmp-group]'), 'sold-out', 'The ' + name + ' just sold out. Pick another or remove it.', [named]);
        return named;
      },
      watch: function (changed) {
        var matchedSeat = seat();
        // Coming back to the page (Back from the cart), the browser ticks the boxes it remembers after this has
        // run and without change events, or brings the whole page back from its cache: take the boxes as they
        // are. A size the shopper had stays as they left it; a group opened without one gets its matched size.
        function retake() {
          matchedSeat = seat();
          $$('[data-show-when]', mount).forEach(function (g) {
            if (g.hidden && ticked(g).length && openerOf(g)) g.hidden = false;
          });
          openGroups();
          $$('[data-show-when]', mount).forEach(function (g) { if (!g.hidden) showFit(g); });
          priceChoosers();
          writePrice();
          changed();
        }
        openGroups();
        priceChoosers();
        writePrice();
        if (priceEl) new MutationObserver(writePrice).observe(priceEl, { childList: true, characterData: true, subtree: true });
        document.addEventListener('dm:b2b-priced', writePrice);
        // Chrome ticks the remembered boxes a few milliseconds after the page has started (Back from the cart
        // or checkout): take them then, rather than at load, which waits seconds for every image and app.
        var arrival = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
        if (arrival && arrival.type === 'back_forward') [60, 250, 700].forEach(function (ms) { setTimeout(retake, ms); });
        window.addEventListener('load', retake);
        window.addEventListener('pageshow', function (e) { if (e.persisted) retake(); });
        mount.addEventListener('change', function (e) {
          var input = e.target;
          if (!input.hasAttribute || !input.hasAttribute('data-dmp-value')) return;
          var group = input.closest('[data-dmp-group]');
          // a group that allows one pick keeps the latest
          if (input.checked && group && !group.hasAttribute('data-several')) {
            ticked(group).forEach(function (other) { if (other !== input) other.checked = false; });
          }
          // the note stops asking once a size is picked, and asks again when it is removed
          if (group && input.hasAttribute('data-fits') && group.hasAttribute('data-show-when')) showFit(group);
          openGroups();
          priceChoosers();
          writePrice();
          changed();
        });
        // "Remove it" under a sold-out message takes the refused add-on off (a refused size takes its cushion with
        // it: what was refused is that cushion in that size) and leaves the focus on it
        mount.addEventListener('click', function (e) {
          var button = e.target.closest ? e.target.closest('[data-dmp-remove]') : null;
          var group = button ? button.closest('[data-dmp-group]') : null;
          var gone = group ? soldOutIn(group) : null;
          if (!gone) return;
          var addOn = addOnOf(gone);
          addOn.checked = false;
          addOn.dispatchEvent(new Event('change', { bubbles: true }));
          addOn.focus();
        });
        // another variant of the main product: a new seat size matches the sizes again; another colour doesn't
        optionWatchers.push(function () {
          if (seat() === matchedSeat) return;
          matchedSeat = seat();
          $$('[data-show-when]', mount).forEach(matchSize);
          priceChoosers();
          writePrice();
          changed();
        });
      }
    };
  }

  /* ---------- Add-ons drawer ---------- */
  var drawer = $('[data-dmp-drawer]');
  var addons = $('[data-dmp-addons]');
  var openBtn = $('[data-dmp-open]');
  var panel = $('[data-dmp-panel]');
  var source = optionSetSource();
  var lastFocus = null;
  var shopPayOff = false; // Shop Pay buys the product alone: off while an add-on is picked or a required group is unanswered

  function sentence(list) {
    return list.map(function (s, i) { return i === 0 ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s.toLowerCase(); });
  }
  function shortList(list) { return list.length > 3 ? list.slice(0, 2).join(', ') + ' and more' : joinList(list); }
  function pagePrice() { var price = document.getElementById('productPrice'); return price ? norm(price.textContent) : ''; }
  // The picked add-ons in the page price, at what the shopper pays and at their regular prices: a linked
  // product's source writes them into it (for a business account, through the wholesale script).
  function addOnCents(regular) {
    return source && source.addsToPagePrice ? source.refresh().groups.reduce(function (sum, g) { return g.shown ? sum + (regular ? g.regularCents : g.cents) : sum; }, 0) : 0;
  }

  function syncTotal() {
    var text = source ? source.total() : pagePrice();
    if (!text) return;
    var total = $('[data-dmp-total]');
    if (total && total.textContent !== text) total.textContent = text;
    var bp = $('[data-dmp-bar-price]');
    if (bp && bp.textContent !== text) bp.textContent = text;
  }

  function refreshAddons() {
    shopPayOff = false;
    if (!source || !addons) return;
    var state = source.refresh();
    if (!state.groups.length) { addons.hidden = true; return; }
    addons.hidden = false;
    var shown = state.groups.filter(function (g) { return g.shown; });
    var tops = shown.filter(function (g) { return !g.dependent; }); // a dependent group is named through its value
    var names = tops.map(function (g) { return g.label; });
    // Only the groups that must be answered are named in the "Choose before adding to cart" line: naming
    // every group there told shoppers to pick optional extras too (the Flexx read "Choose before adding to
    // cart · Elevating legrests, armrests and more" when only the armrests were required).
    var mustNames = tops.filter(function (g) { return g.required; }).map(function (g) { return g.label; });
    var required = mustNames.length > 0;
    var picked = [], notes = [];
    tops.forEach(function (g) { picked = picked.concat(g.picked); notes = notes.concat(g.notes); });
    var chosen = picked.concat(notes); // anything the shopper picked, priced or not

    // An unanswered required group is flagged on the row: a dependent one straight away (the drawer can be
    // closed without it), any other once the source's Add to cart or "Back to product" has asked for it.
    var missing = unanswered(state.groups);
    var gap = missing.filter(function (g) { return g.dependsOn; })[0] || (shown.some(function (g) { return g.flagged; }) ? missing[0] : null);
    shopPayOff = chosen.length > 0 || missing.length > 0; // Shop Pay would buy the product without any of it
    var soldOut = shown.filter(function (g) { return g.soldOut; })[0];

    var sub;
    if (gap) sub = missingText(gap, 'row');
    else if (soldOut) sub = soldOut.soldOut + ' sold out'; // the drawer's message says what to do
    else if (picked.length) sub = picked.length + ' added · ' + shortList(picked);
    else if (notes.length) sub = notes.length + ' chosen · ' + shortList(notes);
    else if (required) sub = 'Choose before adding to cart · ' + shortList(sentence(mustNames));
    else if (state.single) sub = 'Optional · ' + state.single;
    else sub = 'Optional · ' + shortList(sentence(names));
    var subEl = $('[data-dmp-addons-sub]');
    if (subEl && subEl.textContent !== sub) subEl.textContent = sub;
    addons.classList.toggle('has-selection', chosen.length > 0 && !gap && !soldOut);
    addons.classList.toggle('needs-choice', !!gap || !!soldOut);

    var count = $('[data-dmp-count]');
    var need = gap ? gap.label.toLowerCase() : '';
    if (count) count.textContent = gap ? (need ? need.charAt(0).toUpperCase() + need.slice(1) + ' needed' : 'A choice is needed')
      // a non-breaking hyphen: on a phone the balanced footer line would otherwise break "add- / on"
      : soldOut ? 'An add\u2011on sold out'
      : picked.length ? (picked.length === 1 ? '1 add\u2011on added' : picked.length + ' add\u2011ons added')
      // only customizations picked: nothing was added to the cart, a choice was made. Never both clauses
      // at once — "1 add-on added · 1 choice made" is too much to read (Chris, 2026-09-16).
      : notes.length ? (notes.length === 1 ? '1 choice made' : notes.length + ' choices made')
      : 'Nothing added yet';
    var intro = $('[data-dmp-intro]');
    if (intro) intro.textContent = required ? 'Some choices below are needed before adding to cart.'
      : state.matchedTo ? 'Optional. Sizes are matched to your ' + state.matchedTo + ' chair.' : 'Optional. Anything you choose is added to your cart with this item.';
    syncTotal();
  }

  /* Required groups the shopper can see and hasn't answered, such as the seat size that appears once a
     cushion is picked. */
  function unanswered(groups) {
    return groups.filter(function (g) { return g.shown && g.required && !g.answered; });
  }
  function missingText(g, where) {
    var label = g.label.toLowerCase() || 'option';
    var start = 'Choose ' + (/^[aeiou]/.test(label) ? 'an ' : 'a ') + label;
    if (where === 'row') return start + (g.dependsOn ? ' for the ' + g.dependsOn : ' before adding to cart');
    return start + (g.dependsOn ? ' to add the ' + g.dependsOn + '.' : ' to continue.');
  }

  // A flagged group sits in the drawer, so open it there and say what is missing in plain words.
  function showNeeded() {
    var flagged = source ? source.refresh().groups.filter(function (g) { return g.flagged; }) : [];
    if (!flagged.length) return;
    flagged.forEach(function (g) { g.flag(missingText(g, 'drawer')); });
    if (addons) addons.classList.add('needs-choice');
    openDrawer(flagged[0].control);
  }
  // Flags every unanswered required group and opens the drawer at the first; false when there are none.
  function askForMissing() {
    var missing = source ? unanswered(source.refresh().groups) : [];
    if (!missing.length) return false;
    missing.forEach(function (g) { g.flag(missingText(g, 'drawer')); });
    showNeeded();
    refreshSoon();
    return true;
  }

  // A picked add-on Shopify refused as sold out: Add to cart adds nothing until the shopper picks another or
  // removes it, and opens the drawer at it instead; false when there is none.
  function askForSoldOut() {
    var gone = source ? source.refresh().groups.filter(function (g) { return g.shown && g.soldOut; })[0] : null;
    if (!gone) return false;
    openDrawer(gone.control);
    return true;
  }

  // "Back to product" means the shopper is done here, so an unanswered required group keeps the drawer
  // open and gets its message. The close button, the backdrop and Escape still leave; the Add-ons row
  // then says what is missing, and Add to cart brings the shopper back to it.
  function finishDrawer() {
    if (!askForMissing()) closeDrawer();
  }

  // The chat launcher sits bottom-right, on top of everything; while the panel is open it moves
  // beside the panel (desktop) or just above the sheet (phone) instead of covering its buttons.
  // Shopify's theme-preview toolbar is a fixed strip along the bottom of the window in previews. Keep
  // the panel's buttons and the phone bar above it; customers never have it, so this is 0 for them.
  function safeBottom() {
    var bar = document.getElementById('PBarNextFrameWrapper');
    var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--dmp-safe-bottom', h + 'px');
    return h;
  }

  function positionChat(on) {
    var html = document.documentElement;
    if (!on || !drawer) { html.style.removeProperty('--dmp-chat-right'); html.style.removeProperty('--dmp-chat-bottom'); return; }
    var box = drawer.querySelector('.dmp-drawer__panel');
    if (!box) return;
    if (phone.matches) {
      html.style.setProperty('--dmp-chat-right', '12px');
      html.style.setProperty('--dmp-chat-bottom', Math.min(box.offsetHeight + 12, window.innerHeight - 72) + 'px');
    } else {
      html.style.setProperty('--dmp-chat-right', (box.offsetWidth + 24) + 'px');
      html.style.setProperty('--dmp-chat-bottom', (40 + safeBottom()) + 'px');
    }
  }

  function openDrawer(focusEl) {
    if (!drawer) return;
    if (!drawer.classList.contains('is-open')) lastFocus = document.activeElement;
    drawer.removeAttribute('inert');
    if (panel) panel.classList.add('is-drawer-open');
    drawer.classList.add('is-open');
    document.documentElement.classList.add('dmp-lock');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    setBar(false);
    safeBottom();
    positionChat(true);
    setTimeout(function () {
      var target = focusEl || drawer.querySelector('.dmp-drawer__close');
      if (!target) return;
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      // a field's whole fieldset comes into view when it fits, so its message isn't left under the footer
      var set = focusEl && focusEl.closest ? focusEl.closest('fieldset') : null;
      var body = drawer.querySelector('.dmp-drawer__body');
      var shown = set && body && set.offsetHeight <= body.clientHeight ? set : focusEl;
      if (shown && shown.scrollIntoView) shown.scrollIntoView({ block: 'center', behavior: behavior() });
    }, 60);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('inert', '');
    document.documentElement.classList.remove('dmp-lock');
    positionChat(false);
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    setTimeout(function () { if (panel && !drawer.classList.contains('is-open')) panel.classList.remove('is-drawer-open'); }, 340);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); } }
    updateBar();
  }
  document.addEventListener('keydown', function (e) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var box = drawer.querySelector('.dmp-drawer__panel');
    var items = $$('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', box)
      .filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Buy panel position: sticks under the header, or by its bottom when taller than the screen ---------- */
  var probe = $('.dmp-probe');
  function stickTop() { return probe ? probe.getBoundingClientRect().top : 0; }
  function placePanel() {
    if (!panel) return;
    if (!desktop.matches) { panel.style.removeProperty('--dmp-panel-top'); return; }
    var top = stickTop() + 24;
    var h = panel.offsetHeight;
    var vh = window.innerHeight;
    var t = h + top + 24 <= vh ? top : Math.min(top, vh - h - 24);
    panel.style.setProperty('--dmp-panel-top', Math.round(t) + 'px');
  }

  /* ---------- Section menu ---------- */
  var menu = $('[data-dmp-menu]');
  var menuLinks = menu ? $$('.dmp-menu__link', menu) : [];
  var menuTargets = menuLinks.map(function (a) { return document.getElementById(decodeURIComponent(a.hash.slice(1))); });
  // The section the menu's last jump went to, until the shopper scrolls, taps, clicks or types on their own.
  var menuJump = null;
  ['wheel', 'touchstart', 'mousedown', 'keydown'].forEach(function (type) {
    document.addEventListener(type, function () { menuJump = null; }, { passive: true, capture: true });
  });
  // The menu's jump: the section's top just under the pinned header (its scroll-margin-top), and the keyboard's
  // place on its title, so the next Tab goes on from there.
  function focusSection(target) {
    var title = target.querySelector('.dmp-sec__title') || target;
    title.setAttribute('tabindex', '-1');
    try { title.focus({ preventScroll: true }); } catch (err) {}
  }
  function goToSection(target) {
    menuJump = target;
    target.scrollIntoView({ behavior: behavior(), block: 'start' });
    focusSection(target);
  }
  function spy() {
    if (!menu) return;
    var line = stickTop() + menu.offsetHeight + 48;
    var active = 0;
    menuTargets.forEach(function (s, i) { if (s && s.getBoundingClientRect().top <= line) active = i; });
    menuLinks.forEach(function (a, i) {
      a.classList.toggle('is-active', i === active);
      if (i === active) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    var link = menuLinks[active];
    var strip = menu.querySelector('.dmp-menu__list');
    if (link && strip && strip.scrollWidth > strip.clientWidth) {
      var left = link.offsetLeft;
      if (left < strip.scrollLeft || left + link.offsetWidth > strip.scrollLeft + strip.clientWidth) {
        strip.scrollTo({ left: Math.max(0, left - 20), behavior: behavior() });
      }
    }
  }

  /* ---------- Description: wide tables, phone collapses ---------- */
  function prepTables() {
    // Descriptions often carry empty paragraphs (a lone &nbsp; or <br>) as spacers; read straight
    // through on one page they look like gaps where something is missing, so they are left out.
    $$('.dmp-rte p').forEach(function (p) {
      if (p.querySelector('img, iframe, video, table, input, button, a[href]')) return;
      if (p.textContent.replace(/\u00a0/g, ' ').trim() === '') p.classList.add('dmp-empty');
    });
    // Specifications tabs often open with empty <div class="page"><br></div> spacers (about 80px on the PL350CT).
    $$('.dmp-sec--specifications .dmp-rte div').forEach(function (d) {
      if (d.querySelector('img, iframe, video, table, input, button, a[href]')) return;
      if (d.textContent.replace(/\u00a0/g, ' ').trim() === '') d.classList.add('dmp-empty');
    });
    // Many descriptions open a paragraph with a "| Affordability" marker from the old tab design; on one
    // page the pipe reads as a stray character, so the line shows as a plain subheading instead.
    $$('.dmp-rte strong, .dmp-rte b').forEach(function (s) {
      var text = norm(s.textContent);
      if (text.charAt(0) !== '|' || text.length > 60) return;
      var walker = document.createTreeWalker(s, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) { if (node.nodeValue.indexOf('|') > -1) { node.nodeValue = node.nodeValue.replace(/^\s*\|\s*/, ''); break; } }
      var para = s.closest('p');
      if (para && norm(para.textContent) === norm(s.textContent)) { para.classList.add('dmp-subhead'); return; }
      var wrap = s;
      while (wrap.parentElement && wrap.parentElement.tagName === 'SPAN' && norm(wrap.parentElement.textContent) === norm(s.textContent)) wrap = wrap.parentElement;
      wrap.classList.add('dmp-subhead');
      var next = wrap.nextSibling;
      while (next && next.nodeType === 3 && !next.nodeValue.trim()) next = next.nextSibling;
      if (next && next.nodeName === 'BR') next.classList.add('dmp-br-hide');
    });
    $$('.dmp-rte table').forEach(function (t) {
      var max = 0;
      $$('tr', t).forEach(function (tr) { max = Math.max(max, tr.children.length); });
      if (max > 2 && !(t.parentNode.classList && t.parentNode.classList.contains('dmp-table-scroll'))) {
        t.classList.add('dmp-wide');
        var wrap = document.createElement('div');
        wrap.className = 'dmp-table-scroll';
        wrap.tabIndex = 0;
        wrap.setAttribute('role', 'region');
        wrap.setAttribute('aria-label', 'Table, scrolls sideways');
        t.parentNode.insertBefore(wrap, t);
        wrap.appendChild(t);
      }
    });
  }
  function moreButton(text, kind, extra) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dmp-more' + (extra ? ' ' + extra : '');
    b.textContent = text;
    b.setAttribute('data-dmp-more', kind);
    return b;
  }
  function clamps() {
    var on = phone.matches;
    $$('.dmp-sec--description').forEach(function (sec) {
      var body = sec.querySelector('.dmp-sec__body');
      if (!body) return;
      var btn = sec.querySelector('[data-dmp-more="desc"]');
      var collapse = on && !sec.hasAttribute('data-open') && body.scrollHeight > 900;
      body.classList.toggle('is-clamped', collapse);
      if (collapse && !btn) body.insertAdjacentElement('afterend', moreButton('Read the full description', 'desc'));
      if (!collapse && btn) btn.parentNode.removeChild(btn);
    });
  }

  /* ---------- Specifications: six facts, then "Show all N specifications", at every width ---------- */
  // v4.22.0 (direction A, Chris 2026-10-03): the first six facts show, with whatever comes before them; the other rows
  // of the table holding the sixth and everything after it wait behind the button. A fact is a row of two cells or
  // more (a wide table's first row is its header). Every row stays in the HTML, so without script all of them show.
  var SPEC_FACTS = 6;
  function cutSpecs() {
    $$('.dmp-sec--specifications').forEach(function (sec) {
      var body = sec.querySelector('.dmp-sec__body');
      if (!body || sec.hasAttribute('data-dmp-spec-cut')) return;
      sec.setAttribute('data-dmp-spec-cut', '');
      var own = function (t) { return $$('tr', t).filter(function (r) { return r.closest('table') === t; }); };
      var tables = $$('table', body).filter(function (t) { return !t.parentElement.closest('table'); });
      if (!tables.length) return;
      var facts = tables.reduce(function (n, t) {
        var rows = own(t).filter(function (r) { return r.cells.length > 1; }).length;
        return n + rows - (t.classList.contains('dmp-wide') && rows ? 1 : 0);
      }, 0);
      if (facts <= 8) return;
      // Counted on through the tables (v4.23.1): a heading table of one cell ("General" on the Osaki chairs) or a short
      // first table keeps its place and the count goes on in the next one. Counted in the first table alone, 124
      // product pages showed no fact at all before the button.
      var hide = [];
      var shown = 0;
      var last = null;
      tables.forEach(function (t) {
        if (last) return;
        // A wide table's header row isn't a fact (2026-10-06): the ComfyGO X-Lite showed its header and 5 facts.
        var head = t.classList.contains('dmp-wide') ? own(t).filter(function (r) { return r.cells.length > 1; })[0] : null;
        own(t).forEach(function (r) {
          if (shown >= SPEC_FACTS) hide.push(r);
          else if (r.cells.length > 1 && r !== head) shown += 1;
        });
        if (shown >= SPEC_FACTS) last = t;
      });
      if (!last) return;
      var node = last.parentElement.classList.contains('dmp-table-scroll') ? last.parentElement : last;
      for (; node && node !== body; node = node.parentElement) {
        for (var sib = node.nextElementSibling; sib; sib = sib.nextElementSibling) hide.push(sib);
      }
      if (!hide.length) return;
      if (!body.id) body.id = sec.id + '-body';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dmp-more dmp-more--box';
      btn.setAttribute('aria-controls', body.id);
      var set = function (open) {
        hide.forEach(function (el) { el.classList.toggle('dmp-spec-hidden', !open); });
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Show fewer specifications' : 'Show all ' + facts + ' specifications';
      };
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        set(open);
        // Folding back up from far down would leave the shopper in whatever follows; bring the section back.
        if (!open && sec.getBoundingClientRect().top < 0) sec.scrollIntoView({ behavior: behavior(), block: 'start' });
      });
      body.insertAdjacentElement('afterend', btn);
      set(false);
    });
  }

  /* ---------- Videos: the strip and its player ---------- */
  // v4.22.0 (direction A, Chris 2026-10-03; snippets/dmp-videos.liquid). Each card is a link to the video; with
  // script a press opens the native <dialog> instead (focus stays inside it, Escape closes it), which loads the
  // player only then and empties it again on close, and focus goes back to the card of the video last shown.
  var vids = $('[data-dmp-vids]');
  var player = vids && vids.querySelector('[data-dmp-player]');
  var vidCards = vids ? $$('[data-dmp-vid]', vids) : [];
  var playing = -1;
  function vidEmbed(card) {
    var src = card.getAttribute('data-src');
    if (card.getAttribute('data-kind') === 'file') {
      var v = document.createElement('video');
      v.src = src;
      v.controls = true;
      v.autoplay = true;
      v.setAttribute('playsinline', '');
      return v;
    }
    var frame = document.createElement('iframe');
    var extra = /youtube\.com|youtube-nocookie\.com/.test(src) ? 'autoplay=1&rel=0' : 'autoplay=1';
    frame.src = src + (src.indexOf('?') > -1 ? '&' : '?') + extra;
    frame.title = card.getAttribute('data-title') || 'Product video';
    frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen');
    frame.setAttribute('allowfullscreen', '');
    return frame;
  }
  function showVideo(i) {
    var card = vidCards[i];
    if (!card) return;
    // Noted first: the moment a focused button is hidden, the browser moves the focus to the page's body.
    var was = document.activeElement;
    playing = i;
    player.querySelector('.dmp-player__title').textContent = card.getAttribute('data-title') || 'Video ' + (i + 1);
    player.querySelector('[data-dmp-player-pos]').textContent = 'Video ' + (i + 1) + ' of ' + vidCards.length;
    var box = player.querySelector('[data-dmp-player-frame]');
    box.textContent = '';
    box.appendChild(vidEmbed(card));
    $$('[data-dmp-step]', player).forEach(function (b) {
      var to = i + Number(b.getAttribute('data-dmp-step'));
      b.hidden = to < 0 || to >= vidCards.length;
    });
    // A step that just hid can't keep the focus: hand it to the other step, or to Close (v4.22.1).
    if (was && was.hasAttribute && was.hasAttribute('data-dmp-step') && was.hidden) {
      var other = $$('[data-dmp-step]', player).filter(function (b) { return !b.hidden; })[0];
      (other || player.querySelector('[data-dmp-player-close]')).focus();
    }
  }
  function openVideo(i) {
    showVideo(i);
    if (!player.open) player.showModal();
  }
  function syncArrows() {
    var strip = vids && vids.querySelector('[data-dmp-vids-strip]');
    var arrows = vids ? $$('[data-dmp-vids-dir]', vids) : [];
    if (!strip || arrows.length !== 2) return;
    arrows[0].disabled = strip.scrollLeft < 4;
    arrows[1].disabled = strip.scrollLeft + strip.clientWidth > strip.scrollWidth - 4;
  }
  // Card titles (Chris, 2026-10-03: "just have it be the link's title"): a title a person gave in the DM Portal
  // stays (data-named); every other YouTube or Vimeo card takes the video's own title from its oEmbed, asked once
  // per video once the page has loaded or the strip nears (see watchVidTitles), without cookies, kept for the visit
  // in sessionStorage. When that fails (or for a file or a playlist) the card keeps "Video N".
  var dialogs = false;
  // `gone`: the answers that say a video no longer plays here. YouTube: 404 deleted, 403 private, 401 not allowed on
  // other sites. Vimeo: 404 deleted only (its 403 can mean "only on listed sites", which may include this one).
  function oembedFor(href) {
    var m = /^https:\/\/www\.youtube\.com\/watch\?v=([\w-]+)$/.exec(href || '');
    if (m) return { key: 'yt:' + m[1], url: 'https://www.youtube.com/oembed?format=json&url=' + encodeURIComponent(href), gone: [401, 403, 404] };
    m = /^https:\/\/vimeo\.com\/(\d+)(?:\/(\w+))?/.exec(href || ''); // an unlisted video's hash is part of its address
    if (m) return { key: 'vimeo:' + m[1], url: 'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(m[0]), gone: [404] };
    return null;
  }
  // Kept for the visit in place of a title, for a video that no longer plays.
  var VID_GONE = '\u0000gone';
  // A video YouTube or Vimeo says no longer plays leaves the strip, and the Videos section and its menu link go with
  // the last one (bug hunt 2026-10-04: 8 deleted or private videos on 11 product pages opened an error, Chris chose
  // to hide them). Only a plain answer from YouTube or Vimeo counts: a lookup that fails or is blocked hides nothing.
  function dropVid(card) {
    var i = vidCards.indexOf(card);
    if (i < 0 || (player && player.open && playing === i)) return; // never the video being watched
    vidCards.splice(i, 1);
    if (playing > i) playing -= 1;
    var item = card.closest('.dmp-vids__item') || card;
    item.parentNode.removeChild(item);
    if (!vidCards.length) {
      // Noted first: once the section (or its menu link) is gone, the browser moves the focus to the page's body.
      var was = document.activeElement;
      var inside = !!was && was !== document.body && vids.contains(was);
      var jumping = menuJump === vids;
      var at = menuTargets.indexOf(vids);
      var next = null;
      var link = null;
      if (at > -1) {
        menuTargets.splice(at, 1);
        link = menuLinks.splice(at, 1)[0];
        next = menuTargets[at] || menuTargets[at - 1] || null;
      }
      if (!next) {
        for (var sib = vids.nextElementSibling; sib && !next; sib = sib.nextElementSibling) if (sib.hasAttribute('data-dmp-sec')) next = sib;
      }
      var onLink = !!link && !!was && link.contains(was);
      if (link && link.closest('li')) link.closest('li').parentNode.removeChild(link.closest('li'));
      if (vids.parentNode) vids.parentNode.removeChild(vids);
      // A shopper whose menu jump is still on its way to the videos when the last one goes (a press of "Videos" before
      // the answers came, bug hunt 2026-10-04) is taken on to the next section, as its own menu link would. A shopper
      // with the keyboard's place in the section but no jump on its way (they scrolled since, or tabbed in) stays
      // where they are, and the keyboard's place moves to the next section's title without scrolling (review
      // 2026-10-06: the page jumped 2,675px from the top down to Documents).
      if (jumping && next) goToSection(next);
      else if (inside && next) focusSection(next);
      else if (onLink) {
        // Its menu link had the keyboard (not yet pressed): the link beside it takes it.
        var stay = menuLinks[at] || menuLinks[at - 1];
        if (stay) { try { stay.focus({ preventScroll: true }); } catch (err) {} }
      }
      spy();
      return;
    }
    var count = vids.querySelector('.dmp-vids__count');
    if (count) count.textContent = vidCards.length + ' video' + (vidCards.length === 1 ? '' : 's');
    if (vidCards.length < 3) {
      var strip = vids.querySelector('[data-dmp-vids-strip]');
      var nav = vids.querySelector('[data-dmp-vids-nav]');
      if (strip) strip.classList.add('dmp-vids__strip--fit');
      if (nav) nav.hidden = true;
    }
    syncArrows();
  }
  function setVidTitle(card, title) {
    card.setAttribute('data-title', title);
    var t = card.querySelector('.dmp-vids__t');
    if (t) t.textContent = title;
    if (dialogs) card.setAttribute('aria-label', 'Play: ' + title);
    if (player && player.open && vidCards[playing] === card) player.querySelector('.dmp-player__title').textContent = title;
  }
  // Every YouTube or Vimeo card is looked up, a named one too, to learn whether its video still plays; only a card
  // without a name takes the title.
  function loadVidTitles() {
    var asked = {};
    vidCards.slice().forEach(function (card) {
      var named = card.hasAttribute('data-named');
      var o = oembedFor(card.getAttribute('href'));
      if (!o) return;
      var cached = null;
      try { cached = sessionStorage.getItem('dmp-vt:' + o.key); } catch (e) {}
      if (cached === VID_GONE) { dropVid(card); return; }
      if (cached) { if (!named) setVidTitle(card, cached); return; }
      if (!asked[o.key]) {
        var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 5000) : 0;
        asked[o.key] = fetch(o.url, { credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) {
            if (o.gone.indexOf(r.status) > -1) return VID_GONE;
            return r.ok ? r.json().then(function (d) { return d && typeof d.title === 'string' ? norm(d.title) : ''; }) : '';
          })
          .then(function (title) {
            clearTimeout(timer);
            if (title) { try { sessionStorage.setItem('dmp-vt:' + o.key, title); } catch (e) {} }
            return title;
          })
          .catch(function () { clearTimeout(timer); return ''; });
      }
      asked[o.key].then(function (title) {
        if (title === VID_GONE) dropVid(card);
        else if (title && !named) setVidTitle(card, title);
      });
    });
  }
  // Asked once the page has loaded and the browser is idle, or as soon as the strip comes within 800px of the screen,
  // whichever comes first, once only (2026-10-06). Asked only as the strip came near, on a page whose every video was
  // dead the "Videos" link showed until the shopper pressed it, and the section went as they arrived (bug hunt
  // 2026-10-04); asked only after the load, which waits for every app's files, a shopper who reached the strip first
  // on a slow phone saw its dead cards and "Video N" longer (review 2026-10-06: load 3.2 s). dropVid takes a shopper
  // whose menu jump still beats the answers on to the next section. Safari has no requestIdleCallback: a short timeout
  // instead.
  function watchVidTitles() {
    if (!vids || !window.fetch) return;
    var started = false;
    var io = null;
    var start = function () {
      if (started) return;
      started = true;
      if (io) io.disconnect();
      loadVidTitles();
    };
    var idle = function () {
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(start, { timeout: 2000 });
      else setTimeout(start, 300);
    };
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) start();
      }, { rootMargin: '800px 0px' });
      io.observe(vids);
    }
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle);
  }
  function initVideos() {
    watchVidTitles();
    if (!vids || !player || typeof player.showModal !== 'function') return; // the cards stay links to the videos
    dialogs = true;
    vidCards.forEach(function (card) {
      card.removeAttribute('target');
      card.setAttribute('aria-haspopup', 'dialog');
      card.setAttribute('aria-label', 'Play: ' + (card.getAttribute('data-title') || norm(card.textContent)));
      var note = card.querySelector('[data-dmp-newtab]');
      if (note) note.parentNode.removeChild(note);
    });
    var nav = vids.querySelector('[data-dmp-vids-nav]');
    var strip = vids.querySelector('[data-dmp-vids-strip]');
    if (nav && strip) {
      nav.hidden = false;
      strip.addEventListener('scroll', throttle(syncArrows), { passive: true });
      syncArrows();
    }
    // The backdrop (the dialog itself, outside its white box) closes it only when both the press and the release were
    // on it: a press and a release on different elements send the click to their common ancestor, the dialog, so a
    // drag out of the player (its seek bar) would otherwise close it (as c720860 did for the 3D window).
    var pressedOnBackdrop = false;
    var releasedOnBackdrop = false;
    player.addEventListener('pointerdown', function (e) { pressedOnBackdrop = e.target === player; });
    player.addEventListener('pointerup', function (e) { releasedOnBackdrop = e.target === player; });
    player.addEventListener('click', function (e) {
      var backdrop = e.target === player && pressedOnBackdrop && releasedOnBackdrop;
      pressedOnBackdrop = releasedOnBackdrop = false;
      if (backdrop) { player.close(); return; }
      if (e.target === player) return;
      var step = e.target.closest('[data-dmp-step]');
      if (step) { showVideo(playing + Number(step.getAttribute('data-dmp-step'))); return; }
      if (e.target.closest('[data-dmp-player-close]')) player.close();
    });
    player.addEventListener('close', function () {
      player.querySelector('[data-dmp-player-frame]').textContent = ''; // stops the video
      var card = vidCards[playing];
      if (card) { try { card.focus({ preventScroll: false }); } catch (err) { card.focus(); } }
    });
  }

  /* ---------- Video inside the Description text: load the player in place when pressed ---------- */
  function playVideo(btn) {
    var src = btn.getAttribute('data-dmp-video');
    if (!src) return;
    var frame = document.createElement('iframe');
    frame.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
    frame.title = 'Product video';
    frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    frame.setAttribute('allowfullscreen', '');
    btn.parentNode.replaceChild(frame, btn);
    frame.focus();
  }

  /* ---------- Phone bar ---------- */
  var bar = $('[data-dmp-bar]');
  var barBtn = $('[data-dmp-bar-atc]');
  var barLabel = barBtn ? barBtn.textContent : '';
  var actions = $('.dmp-actions');
  var pastActions = false;
  function setBar(on) {
    if (!bar) return;
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (barBtn) barBtn.tabIndex = on ? 0 : -1;
    document.documentElement.classList.toggle('dmp-bar-on', on);
  }
  function updateBar() { setBar(pastActions && phone.matches && !(drawer && drawer.classList.contains('is-open'))); }
  function syncBarState() {
    var atc = document.getElementById('addToCart');
    if (!barBtn || !atc) return;
    var off = !!atc.disabled;
    barBtn.disabled = off;
    barBtn.textContent = off ? (atc.value || barLabel) : barLabel;
  }
  function addFromBar() {
    var button = source && source.addButton();
    if (button && button.offsetParent !== null) { button.click(); return; }
    var atc = document.getElementById('addToCart');
    if (atc && !atc.disabled) atc.click();
  }

  /* ---------- Clicks ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el;
    if ((el = t.closest('[data-dmp-open]'))) { e.preventDefault(); openDrawer(); return; }
    if ((el = t.closest('[data-dmp-done]'))) { e.preventDefault(); finishDrawer(); return; }
    if ((el = t.closest('[data-dmp-close]'))) { e.preventDefault(); closeDrawer(); return; }
    if ((el = t.closest('[data-dmp-video]'))) { e.preventDefault(); playVideo(el); return; }
    if ((el = t.closest('[data-dmp-vid]')) && player && typeof player.showModal === 'function') {
      e.preventDefault();
      openVideo(vidCards.indexOf(el));
      return;
    }
    if ((el = t.closest('[data-dmp-vids-dir]'))) {
      var strip = el.closest('[data-dmp-vids]').querySelector('[data-dmp-vids-strip]');
      if (strip) strip.scrollBy({ left: Number(el.getAttribute('data-dmp-vids-dir')) * strip.clientWidth * 0.9, behavior: behavior() });
      return;
    }
    if ((el = t.closest('[data-dmp-bar-atc]'))) { e.preventDefault(); addFromBar(); return; }
    if ((el = t.closest('[data-dmp-more]'))) {
      var sec = el.closest('.dmp-sec');
      if (sec) { sec.setAttribute('data-open', ''); clamps(); }
      return;
    }
    // What owners like (snippets/dmp-review-gist.liquid): a topic chip opens its owners' words under the chips, one
    // topic at a time; pressing the open one closes it. The keyboard's place stays on the chip.
    if ((el = t.closest('[data-dmp-gist-chip]'))) {
      var gist = el.closest('[data-dmp-gist]');
      var opening = el.getAttribute('aria-expanded') !== 'true';
      Array.prototype.forEach.call(gist.querySelectorAll('[data-dmp-gist-chip]'), function (chip) {
        var on = opening && chip === el;
        chip.setAttribute('aria-expanded', on ? 'true' : 'false');
        var panel = document.getElementById(chip.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      return;
    }
    if ((el = t.closest('[data-dmp-review]'))) {
      var widget = document.getElementById('judgeme_product_reviews');
      if (!widget) return;
      e.preventDefault();
      // Judge.me's script draws the widget as the page loads (1,772px on the PL182); without it (blocked, or down)
      // the widget has no height, and going there would leave the shopper at the foot of the page with no reviews.
      if (widget.offsetHeight < 40) return;
      // Judge.me's own button opens and closes its form: when the form already shows (a second press), only go to it.
      var form = [].slice.call(widget.querySelectorAll('[class*="jdgm-form"]')).filter(function (f) { return f.getClientRects().length && f.offsetHeight > 80; })[0];
      var writing = el.getAttribute('data-dmp-review') === 'write' && !form;
      (form || widget).scrollIntoView({ behavior: behavior(), block: 'start' });
      // The keyboard's place follows, to the widget's heading (as the section menu's links do), not left on a
      // button now off the screen.
      var head = widget.querySelector('.jdgm-rev-widg__title') || widget;
      head.setAttribute('tabindex', '-1');
      try { head.focus({ preventScroll: true }); } catch (err) {}
      if (writing) {
        // Judge.me draws its widget only once it scrolls into view, so its "Write a review" button may not be
        // there yet: look for it for up to 4 seconds and press it once it shows; if it never does, the shopper
        // is left at the widget.
        var tries = 0;
        var press = function () {
          var w = widget.querySelector('.jdgm-write-rev-link');
          if (w && w.getClientRects().length) { w.click(); return; }
          if (++tries < 27) setTimeout(press, 150);
        };
        setTimeout(press, 150);
      }
      return;
    }
    if ((el = t.closest('.dmp-menu__link'))) {
      var target = document.getElementById(decodeURIComponent(el.hash.slice(1)));
      if (!target) return;
      e.preventDefault();
      goToSection(target);
    }
  });

  /* ---------- Call line: shown only inside the business hours set in Gorgias ---------- */
  var callLine = $('[data-dmp-call]');
  function syncCallLine() {
    var gc = window.GorgiasChat;
    if (!callLine || !gc || typeof gc.isBusinessHours !== 'function') return;
    var open;
    try { open = gc.isBusinessHours(); } catch (e) { return; }
    if (typeof open === 'boolean') callLine.hidden = !open;
  }
  function watchGorgias() {
    if (!callLine) return;
    var started = false;
    function start() {
      if (started || !window.GorgiasChat) return;
      started = true;
      var ready = typeof window.GorgiasChat.init === 'function' ? window.GorgiasChat.init() : null;
      Promise.resolve(ready).then(function () { syncCallLine(); setInterval(syncCallLine, 60000); }, function () {});
    }
    if (window.GorgiasChat) start();
    window.addEventListener('gorgias-widget-loaded', start);
  }

  /* ---------- Popular chip: on the main photo for a few seconds (snippets/dmp-popular-chip.liquid) ---------- */
  // Chris's pick (9 Oct 2026): "Popular · 23+ visitors in 7 days" on products with 10 or more visitors in 7 days,
  // from the product metafield custom.dm_popular that the DM Portal writes nightly ({"v":1,"visitors","days",
  // "through"}). The snippet prints the chip and its screen-reader note only when v, visitors and days pass, both
  // hidden; this part decides the rest in the browser, since Shopify caches the page:
  // - `through` (the last whole day counted) must be at most 2 days before the shopper's today, so a stalled
  //   nightly run hides the chip rather than showing an old count; the note shows from then on;
  // - the chip comes once per product per browser session (sessionStorage `dmp-pop:<product id>`, set when it
  //   shows), 1.2 s after the main photo has loaded, and only once its spot is on screen, below the pinned header
  //   and clear of anything fixed over it; not clear in the first 30 s on the page, it skips that visit. Both
  //   times count from when the shopper first sees the page (a background tab waits for its first look). From
  //   768px up the CSS puts it at the photo's bottom right, away from Google's "Top Quality Store" badge
  //   (#merchantwidgetiframe) and the Rewards launcher at the window's bottom left, but a chat button or another
  //   launcher could still sit on it on some layout; on phones (bottom left) the badge is hidden by
  //   layout/theme.liquid;
  // - it stays 5 s after rising in, then fades out; a change of photo, the 3D button or the badge coming over it
  //   sends it out at once. The CSS draws the motion, and none with reduced motion.
  // The chip's data-verdict says what was decided, for the checks: "show", or the rule the values failed, "seen"
  // (already shown this session), "late" (its spot wasn't clear in 30 s), "photo" (no photo loaded), "3d".
  // tools/theme-tests/popular-chip.test.mjs runs this part without a browser, from the line below to "end of the
  // Popular chip"; it uses only root, calm and throttle from outside it.
  var POP_MIN = 10, POP_MAX_AGE = 2, POP_DELAY = 1200, POP_IN = 320, POP_STAY = 5000, POP_OUT = 400, POP_GIVE_UP = 30000;
  // A 'YYYY-MM-DD' day as a count of days, or NaN for anything else (a day that doesn't exist too).
  function popularDay(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s == null ? '' : s));
    if (!m) return NaN;
    var t = Date.UTC(+m[1], +m[2] - 1, +m[3]), d = new Date(t);
    if (d.getUTCFullYear() !== +m[1] || d.getUTCMonth() !== +m[2] - 1 || d.getUTCDate() !== +m[3]) return NaN;
    return t / 864e5;
  }
  // "show", or the rule the values fail. `now` is the shopper's clock: their own date counts, not the store's.
  // A `through` a day ahead of the shopper's today is a shopper west of the store just after its midnight.
  function popularVerdict(d, now) {
    if (!d || Number(d.v) !== 1) return 'version';
    var n = Number(d.visitors), days = Number(d.days);
    if (!(n >= POP_MIN)) return 'few';
    if (!(days >= 1 && days <= 7) || days % 1) return 'days';
    var through = popularDay(d.through);
    if (isNaN(through)) return 'through';
    var age = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) / 864e5 - through;
    if (age > POP_MAX_AGE) return 'stale';
    if (age < -1) return 'ahead';
    return 'show';
  }
  function popularSeen(store, key) { try { return !!store && store.getItem('dmp-pop:' + key) === '1'; } catch (e) { return false; } }
  function popularMarkSeen(store, key) { try { if (store) store.setItem('dmp-pop:' + key, '1'); } catch (e) {} }

  function startPopular() {
    var chip = root.querySelector('[data-dmp-pop]');
    if (!chip) return;
    var verdict = popularVerdict({
      v: chip.getAttribute('data-v'), visitors: chip.getAttribute('data-visitors'),
      days: chip.getAttribute('data-days'), through: chip.getAttribute('data-through')
    }, new Date());
    chip.setAttribute('data-verdict', verdict);
    if (verdict !== 'show') return;
    var note = root.querySelector('[data-dmp-pop-note]');
    if (note) note.hidden = false;
    var store = null;
    try { store = window.sessionStorage; } catch (e) {}
    var key = chip.getAttribute('data-key');
    if (popularSeen(store, key)) { chip.setAttribute('data-verdict', 'seen'); return; }

    var slider = document.getElementById('product-slider');
    var probe = root.querySelector('.dmp-probe');
    var state = 'wait', shownOn = null, poll = null, timer = null, observer = null, photoIn = false;
    // When the shopper first saw the page (performance.now()): navigation for a page visible at load, else the
    // first visibilitychange to visible, so a product opened in a background tab waits for its first look.
    // The 1.2 s and the 30 s count from then.
    var since = document.hidden ? -1 : 0;
    function seen() { if (since < 0 && !document.hidden) { since = window.performance.now(); if (photoIn) loaded(); } }
    function late() { return window.performance.now() - since > POP_GIVE_UP; }
    document.addEventListener('visibilitychange', seen);
    // in the page but invisible (the CSS), so its spot can be measured
    chip.hidden = false;

    function activeSlide() { return slider ? slider.querySelector('.splide__slide.is-active') : null; }
    function clear() {
      if (document.hidden) return false;
      var r = chip.getBoundingClientRect();
      var top = probe ? probe.getBoundingClientRect().top : 0;
      if (!r.width || r.top < top || r.bottom > window.innerHeight || r.left < 0 || r.right > window.innerWidth) return false;
      return !covered(r);
    }
    // Something fixed over its spot, 8px around it included: a chat button, Google's badge or a rewards
    // launcher. Asked of the page itself (what is on top at its corners and middle; the chip takes
    // no pointer, so the photo answers when nothing covers it), since the badge's iframe has a far larger box
    // than the badge it shows: 720 x 904px on a 1440 window, clipped by a wrapper the size of the badge.
    function covered(r) {
      var frame = chip.parentElement, gap = 8;
      var x = [r.left - gap, (r.left + r.right) / 2, r.right + gap], y = [r.top - gap, (r.top + r.bottom) / 2, r.bottom + gap];
      for (var i = 0; i < 3; i++) for (var j = 0; j < 3; j++) {
        var px = Math.min(Math.max(x[i], 0), window.innerWidth - 1), py = Math.min(Math.max(y[j], 0), window.innerHeight - 1);
        var hit = document.elementFromPoint(px, py);
        if (!hit || !frame.contains(hit)) return true;
      }
      return false;
    }
    var check = throttle(function () {
      if (state === 'ready') { if (late()) skip('late'); else if (clear()) show(); }
      else if (state === 'in' && covered(chip.getBoundingClientRect())) leave();
    });
    function listen(on) {
      var f = on ? 'addEventListener' : 'removeEventListener';
      window[f]('scroll', check, { passive: true });
      window[f]('resize', check);
      document[f]('visibilitychange', check);
      if (poll) { clearInterval(poll); poll = null; }
      if (on) poll = setInterval(check, 500);
    }
    function ready() {
      if (state !== 'wait') return;
      if (late()) return skip('late');
      state = 'ready';
      listen(true);
      if (clear()) show();
    }
    function show() {
      state = 'in';
      shownOn = activeSlide();
      popularMarkSeen(store, key);
      chip.setAttribute('data-state', 'in');
      timer = setTimeout(leave, POP_IN + POP_STAY);
    }
    function leave() {
      if (state !== 'in') return;
      state = 'out';
      clearTimeout(timer);
      chip.setAttribute('data-state', 'out');
      timer = setTimeout(done, calm.matches ? 0 : POP_OUT);
    }
    function done() {
      state = 'done';
      listen(false);
      document.removeEventListener('visibilitychange', seen);
      if (observer) observer.disconnect();
      chip.removeAttribute('data-state');
      chip.hidden = true;
    }
    function skip(why) {
      if (state === 'done') return;
      chip.setAttribute('data-verdict', why);
      done();
    }
    // A change of photo while it shows (an arrow, a thumbnail, a swipe, a dot, an option with its own photo):
    // Splide moves is-active to another slide. One before it shows only changes the photo it will sit on.
    if (slider && 'MutationObserver' in window) {
      observer = new MutationObserver(function () {
        if (state === 'in' && activeSlide() && activeSlide() !== shownOn) leave();
      });
      observer.observe(slider, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
    var view3d = document.getElementById('view3D');
    if (view3d) view3d.addEventListener('click', function () { if (state === 'in') leave(); else if (state === 'wait' || state === 'ready') skip('3d'); });

    // The photo it sits on: 1.2 s after it has loaded and the page has been seen. No photo, or one that fails,
    // and it doesn't come.
    var photo = slider && (slider.querySelector('.splide__slide.is-active img') || slider.querySelector('.splide__slide img'));
    function loaded() { photoIn = true; if (state === 'wait' && since >= 0) timer = setTimeout(ready, POP_DELAY); }
    if (!photo) return skip('photo');
    if (photo.complete) { if (photo.naturalWidth > 0) loaded(); else skip('photo'); }
    else {
      photo.addEventListener('load', loaded, { once: true });
      photo.addEventListener('error', function () { if (state === 'wait') skip('photo'); }, { once: true });
    }
  }
  // end of the Popular chip

  /* ---------- Start ---------- */
  // Shop Pay buys the product alone, so on a linked product it shows until an add-on is picked or a required
  // group is unanswered; its empty wrapper would leave a gap in the panel, so the wrapper hides with it.
  function syncDynamic() {
    var dyn = $('.dmp-dynamic');
    if (!dyn) return;
    var btn = dyn.querySelector('.shopify-payment-button');
    var shown = !!btn && !shopPayOff && btn.style.display !== 'none' && getComputedStyle(btn).display !== 'none';
    if (dyn.hidden === shown) dyn.hidden = !shown;
  }
  // The theme's quantity box takes any text; keep it a whole number of at least 1, including on the
  // way to the cart.
  // Adding to cart posts the form and Shopify redirects to /cart, so there is a pause with the
  // shopper still looking at the product page. Say what is happening the moment they click.
  function markAdding() {
    var sourceBtn = source && source.addButton(), atc = $('#addToCart');
    var btn = sourceBtn && getComputedStyle(sourceBtn).display !== 'none' ? sourceBtn : atc;
    if (btn && !btn.classList.contains('is-adding')) {
      btn.classList.add('is-adding');
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('data-dmp-label', 'value' in btn ? btn.value : btn.textContent);
      if ('value' in btn) btn.value = 'Adding\u2026'; else btn.textContent = 'Adding\u2026';
    }
    var bar = $('[data-dmp-bar-atc]');
    if (bar) { bar.classList.add('is-adding'); bar.textContent = 'Adding\u2026'; }
  }
  function doneAdding() {
    $$('.is-adding').forEach(function (el) {
      el.classList.remove('is-adding');
      el.removeAttribute('aria-busy');
      var label = el.getAttribute('data-dmp-label');
      if (label === null) return;
      if ('value' in el) el.value = label; else el.textContent = label;
    });
    syncBarState();
  }

  // A linked product's add-ons go into the cart in the same request as the product (ADR-0001): each is
  // its own line for its product, at the product's quantity, with a "For" note naming the product and
  // variant. The product's line lists its add-ons, and a hidden link property ties the lines together.
  var addingWithAddons = false;
  function addWithAddons(addOns) {
    var variant = currentVariant();
    if (addingWithAddons) return;
    addingWithAddons = true;
    var qtyBox = $('#quantity');
    var qty = parseInt(qtyBox && qtyBox.value, 10) || 1;
    var link = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    // the form's other line item properties ride along on the product's line
    var properties = {};
    $$('[name^="properties["]', form).forEach(function (el) {
      if (el.disabled || ((el.type === 'checkbox' || el.type === 'radio') && !el.checked)) return;
      properties[el.name.replace(/^properties\[(.*)\]$/, '$1')] = el.value;
    });
    properties['Add-ons'] = addOns.map(function (a) { return a.line; }).join(', ');
    properties._add_on_link = link;
    var forText = product.title + (variant.title !== 'Default Title' ? ' – ' + variant.title : '');
    var items = [{ id: variant.id, quantity: qty, properties: properties }].concat(addOns.map(function (a) {
      return { id: a.id, quantity: qty, properties: { For: forText, _add_on_link: link } };
    }));
    markAdding();
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (body) { throw body; }, function () { throw {}; });
        window.location.href = '/cart';
      })
      .catch(function (err) {
        // Shopify added nothing. When it names an add-on it can't sell, the drawer reopens on that add-on
        // with every other choice kept; otherwise the footer says what Shopify said, and takes the focus so
        // a screen reader reads it.
        addingWithAddons = false;
        doneAdding();
        var words = err && typeof err.description === 'string' ? err.description : '';
        var gone = words && source ? source.soldOut(words) : null;
        if (gone) { refreshSoon(); openDrawer(gone); return; }
        var count = $('[data-dmp-count]');
        if (count) {
          count.textContent = words || 'This couldn’t be added to your cart. Please try again.';
          count.setAttribute('tabindex', '-1');
        }
        openDrawer(count);
      });
  }
  function clampQty() {
    var q = $('#quantity');
    if (!q) return;
    var n = parseInt(String(q.value).replace(/[^0-9]/g, ''), 10);
    if (!n || n < 1) n = 1;
    if (String(n) !== String(q.value)) q.value = n;
  }
  function refreshAll() { refreshAddons(); syncPrice(); syncTotal(); syncDynamic(); }
  var refreshSoon = throttle(refreshAll);

  function init() {
    prepTables();
    cutSpecs();
    clamps();
    initVideos();
    paintOptions();
    paintNotes();
    syncPrice();
    syncEta();
    refreshAll();
    placePanel();
    spy();
    syncBarState();
    safeBottom();
    watchGorgias();
    syncDynamic();
    startPopular();
    var qtyBox = $('#quantity');
    if (qtyBox) { qtyBox.addEventListener('change', clampQty); qtyBox.addEventListener('blur', clampQty); }
    if (form) form.addEventListener('submit', function (e) {
      clampQty();
      // A source without an Add to cart of its own (a linked product) has its required groups and sold-out
      // add-ons checked here.
      if (!addingWithAddons && source && !source.addButton() && (askForMissing() || askForSoldOut())) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      var addOns = source ? source.pickedAddOns() : [];
      if (addingWithAddons || (addOns.length && currentVariant())) {
        e.preventDefault();
        e.stopImmediatePropagation();
        addWithAddons(addOns); // a second tap while the first add is on its way does nothing
        return;
      }
      markAdding();
    }, true);
    var dynamicBox = $('.dmp-dynamic');
    if (dynamicBox) new MutationObserver(throttle(syncDynamic)).observe(dynamicBox, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class'] });

    if (etaBox) new MutationObserver(syncEta).observe(etaBox, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style'] });
    // The date script writes 0.5 s after DOMContentLoaded; should it never write, the held room goes after 4 s.
    setTimeout(releaseShip, 4000);

    if (source) source.watch(refreshSoon, showNeeded);

    var price = document.getElementById('productPrice');
    if (price) new MutationObserver(throttle(function () { syncTotal(); })).observe(price, { childList: true, characterData: true, subtree: true });
    var save = $('.save-tag');
    if (save && isB2B) new MutationObserver(function () { syncPrice(); }).observe(save, { childList: true, characterData: true, subtree: true });
    var atc = document.getElementById('addToCart');
    if (atc) new MutationObserver(syncBarState).observe(atc, { attributes: true, attributeFilter: ['disabled', 'value', 'class'] });

    if (panel && 'ResizeObserver' in window) new ResizeObserver(throttle(placePanel)).observe(panel);
    window.addEventListener('resize', throttle(function () { placePanel(); clamps(); syncArrows(); spy(); safeBottom(); if (drawer && drawer.classList.contains('is-open')) positionChat(true); }));
    window.addEventListener('scroll', throttle(spy), { passive: true });
    onMedia(phone, function () { clamps(); updateBar(); });
    onMedia(desktop, placePanel);

    // Whether Add to cart has scrolled above the screen, checked on scroll: an intersection observer
    // misses a jump straight past the button (a section-menu tap on a phone skips over it).
    if (bar && actions) {
      var checkBar = function () {
        var past = actions.getBoundingClientRect().bottom < 0;
        if (past !== pastActions) { pastActions = past; updateBar(); }
      };
      window.addEventListener('scroll', throttle(checkBar), { passive: true });
      checkBar();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', function () { paintOptions(); paintNotes(); syncPrice(); syncDynamic(); placePanel(); clamps(); spy(); });
  // Back to a page the browser kept in its cache after an add to cart: that add is no longer on its way.
  window.addEventListener('pageshow', function (e) { if (e.persisted) { addingWithAddons = false; doneAdding(); } });
})();
